// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-width-select[data-v-140a6c15]{width:100%;min-width:190px}.fixed-feedback[data-v-140a6c15]{min-height:20px;line-height:20px}.card[data-v-140a6c15]{-webkit-box-shadow:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;
